enum DASHBOARD_ACTION_TYPES {
    SET_PBI_DASHBOARD_DATA = 'SET_PBI_DASHBOARD_DATA',
    SET_DASHBOARD_FILTER = 'SET_DASHBOARD_FILTER',
    LOGOUT = 'LOGOUT',
}

export default DASHBOARD_ACTION_TYPES;